var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIco1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.28,
    height: 81.28,
    viewBox: "0 0 81.28 81.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "innovation_sq-01-square",
    transform: "translate(0.52 0.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 57.433,
    height: 57.433,
    transform: "translate(11.317 11.767)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y1: 11.3,
    x2: 11.307,
    transform: "translate(0.01 69.2)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y1: 11.267,
    x2: 11.26,
    transform: "translate(68.75 0.5)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 7.38,
    transform: "translate(68.75 62.787)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 7.4,
    transform: "translate(68.75 47.927)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x1: 7.4,
    transform: "translate(68.75 55.353)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x1: 7.427,
    transform: "translate(3.89 18.213)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x1: 7.427,
    transform: "translate(3.89 25.647)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x1: 7.427,
    transform: "translate(3.89 33.073)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x1: 14.98,
    y2: 14.987,
    transform: "translate(17.357 48.173)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "5 3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y1: 14.82,
    x2: 14.82,
    transform: "translate(47.697 18)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    strokeDasharray: "5 3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80240",
    "data-name": "Path 80240",
    d: "M52,43.06l9.44,9.427L52,61.913l-9.42-9.427L52,43.06m0-6.6-16,16,16,16,16.033-16Z",
    transform: "translate(-11.997 -11.987)",
    fill: "#12784a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 3.333,
    height: 3.333,
    transform: "translate(19.4 64.449) rotate(179.99)",
    fill: "#323232",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 3.333,
    height: 3.333,
    transform: "translate(60.63 16.547)",
    fill: "#fff",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80241",
    "data-name": "Path 80241",
    d: "M117.677,5.167V.5H113.01",
    transform: "translate(-37.667)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 34.887,
    height: 34.887,
    transform: "translate(22.57 23.053)",
    fill: "none",
    stroke: "#323232",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco1);
export default __webpack_public_path__ + "static/media/ico1.fd428e3e5be4c58675aad7e581966316.svg";
export { ForwardRef as ReactComponent };